/**
 * Tier 閾值與季節性邏輯
 */
// Tier 配置表
export const TIER_CONFIGS = [
    {
        tier: 'A',
        name: '旺季攻勢',
        months: [12, 1, 2, 3],
        cplThreshold: 4500,
        strategy: '全力進攻，預算無上限'
    },
    {
        tier: 'B',
        name: '穩定期',
        months: [4, 5, 6, 7],
        cplThreshold: 6000,
        strategy: '清洗雜訊，優化 Persona'
    },
    {
        tier: 'C',
        name: '淡季防守',
        months: [8, 9, 10, 11],
        cplThreshold: 7500,
        strategy: '極端防守，轉投品牌字'
    }
];
/**
 * 根據月份取得當前 Tier
 */
export function getCurrentTier(month) {
    const tier = TIER_CONFIGS.find(t => t.months.includes(month));
    if (!tier) {
        // 預設使用 Tier C（最保守）
        return TIER_CONFIGS[2];
    }
    return tier;
}
/**
 * 計算 CPL (Cost Per Lead / 轉換成本)
 */
export function calculateCpl(costMicros, conversions) {
    if (conversions <= 0)
        return null;
    return (costMicros / 1000000) / conversions;
}
/**
 * 計算 CTR (Click Through Rate / 點擊率)
 */
export function calculateCtr(clicks, impressions) {
    if (impressions <= 0)
        return null;
    return (clicks / impressions) * 100;
}
/**
 * 計算 CPC (Cost Per Click / 單次點擊成本)
 */
export function calculateCpc(costMicros, clicks) {
    if (clicks <= 0)
        return null;
    return (costMicros / 1000000) / clicks;
}
/**
 * 格式化金額為 TWD
 */
export function formatCurrency(amount) {
    return new Intl.NumberFormat('zh-TW', {
        style: 'currency',
        currency: 'TWD',
        maximumFractionDigits: 0
    }).format(amount);
}
/**
 * 取得分析窗口日期範圍（過去 14 天）
 */
export function getAnalysisWindow() {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 14);
    return {
        start: start.toISOString().split('T')[0],
        end: end.toISOString().split('T')[0]
    };
}
